import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { BaseComponent } from '~Interfaces/basecomponent';
import { AuthentificationService } from '../../services/authentification.service';

/**
 * Composant de connexion
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-connexion',
  templateUrl: './connexion.component.html',
    styleUrls: ['./connexion.component.scss']
})
export class ConnexionComponent extends BaseComponent implements OnInit {
    login: string;
    password: string;
    rememberMe: boolean = true;
    returnUrl: string;
    loading: boolean = false;
    subscription: Subscription;

    /**
     * Constructeur
     * @param authentificationService
     * @param route
     * @param router
     */
    constructor(
        @Inject(AuthentificationService) private authentificationService: AuthentificationService,
        private route: ActivatedRoute,
        private router: Router)
    {
        super();
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        // D�finit l'URL de retour (par d�faut la page d'accueil)
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/accueil';

        // Si l'utilisateur est d�j� connect�
        this.authentificationService.estConnecte().subscribe((estConnecte) => {
            if (estConnecte === true) {
                // Rediriger vers la page de retour
                this.router.navigate([this.returnUrl]);
            } else {
                // R�cup�ration du token
                let paramlogin = this.route.snapshot.queryParams['login'];
                if (paramlogin)
                {
                    this.router.navigate([], {
                        queryParams: {
                            'login': null, 
                            'returnUrl': null
                        },
                        queryParamsHandling: 'merge'
                    });
                    this.login = paramlogin;
                }
            }
        });
    }

    /**
     * Connexion de l'utilisateur
     */
    connexion(): void {
        this.loading = true;
        // Connexion
        this.authentificationService.connexion(this.login, this.password, this.rememberMe).subscribe((retour) => {
            this.loading = false;
            let ret = (retour as any);
            // Connexion OK
            if (ret.Result) {
                // Redirection
                let returnUrl = ret.ReturnUrl ? ret.ReturnUrl : this.returnUrl;
                window.location.href = returnUrl;
                //this.router.navigateByUrl(returnUrl);
            }
        }, (erreur) => {
            this.loading = false;
            console.error(erreur);
        });
    }

}
